import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { IContractManagement } from '../IContractManagement';
import { IChargeNumberManagement } from '../IChargeNumberManagement';
import { Action } from 'rxjs/internal/scheduler/Action';

export const getContracts = createAction(
    '[ContractManagement/API] Get Contracts',
    props<{ Activeonly?: boolean }>()
);

export const putContracts = createAction(
    '[ContractManagement/API] Update Contracts',
    props<{ contracts: Array<IContractManagement>; Activeonly?: boolean }>()
);

export const loadContractManagements = createAction(
    '[ContractManagement/API] Load ContractManagements',
    props<{ contractManagements: IContractManagement[] }>()
);

export const addContractManagement = createAction(
    '[ContractManagement/API] Add ContractManagement',
    props<{ contractManagement: IContractManagement }>()
);

export const upsertContractManagement = createAction(
    '[ContractManagement/API] Upsert ContractManagement',
    props<{ contractManagement: IContractManagement }>()
);

export const addContractManagements = createAction(
    '[ContractManagement/API] Add ContractManagements',
    props<{ contractManagements: IContractManagement[] }>()
);

export const upsertContractManagements = createAction(
    '[ContractManagement/API] Upsert ContractManagements',
    props<{ contractManagements: IContractManagement[] }>()
);

export const updateContractManagement = createAction(
    '[ContractManagement/API] Update ContractManagement',
    props<{ contractManagement: Update<IContractManagement> }>()
);

export const updateContractManagements = createAction(
    '[ContractManagement/API] Update ContractManagements',
    props<{ contractManagements: Update<IContractManagement>[] }>()
);

export const deleteContractManagement = createAction(
    '[ContractManagement/API] Delete ContractManagement',
    props<{ id: string }>()
);

export const deleteContractManagements = createAction(
    '[ContractManagement/API] Delete ContractManagements',
    props<{ ids: string[] }>()
);

export const clearContractManagements = createAction(
    '[ContractManagement/API] Clear ContractManagements'
);
